import {
  // -- GET (list)
  GET_SCENARIO_LOCATIONS_SUCCESS,
  GET_SCENARIO_LOCATIONS_FAILURE,
  // -- CREATE
  CREATE_SCENARIO_LOCATION_SUCCESS,
  CREATE_SCENARIO_LOCATION_FAILURE,
  // -- UPDATE
  UPDATE_SCENARIO_LOCATION_SUCCESS,
  UPDATE_SCENARIO_LOCATION_FAILURE,
  // -- DELETE
  DELETE_SCENARIO_LOCATION_SUCCESS,
  DELETE_SCENARIO_LOCATION_FAILURE,
  // -- SEARCH
  SEARCH_SCENARIO_LOCATIONS
} from '../../../actions'
import { Logger, LoggerTypes } from '../../../utils'

let cacheItems = null

export const scenarioLocations = (state = {}, action) => {
  switch (action.type) {
    // -- GET SCENARIO LOCATIONS (list)
    case GET_SCENARIO_LOCATIONS_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioLocations.GET_SCENARIO_LOCATIONS_FAILURE()', { state, action })
      return { ...state, error: action.data }
    }
    case GET_SCENARIO_LOCATIONS_SUCCESS: {
      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioLocations.GET_SCENARIO_LOCATIONS_SUCCESS()', {
        state,
        action
      })
      return {
        ...state,
        items: action.data
      }
    }

    // -- CREATE SCENARIO LOCATION
    case CREATE_SCENARIO_LOCATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioLocations.CREATE_SCENARIO_LOCATION_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case CREATE_SCENARIO_LOCATION_SUCCESS: {
      let newItems = [...state.items]
      newItems.push(action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioLocations.CREATE_SCENARIO_LOCATION_SUCCESS()', {
        state,
        action,
        newItems
      })
      return {
        ...state,
        items: newItems
      }
    }

    // -- UPDATE SCENARIO LOCATION
    case UPDATE_SCENARIO_LOCATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioLocations.UPDATE_SCENARIO_LOCATION_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case UPDATE_SCENARIO_LOCATION_SUCCESS: {
      const items = state.items.map((obj) => [action.data].find((o) => o.id === obj.id) || obj)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioLocations.UPDATE_SCENARIO_LOCATION_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- DELETE SCENARIO LOCATION
    case DELETE_SCENARIO_LOCATION_FAILURE: {
      Logger.trace(LoggerTypes.WARN, '[REDUCER] scenarioLocations.DELETE_SCENARIO_LOCATION_FAILURE()', {
        state,
        action
      })
      return { ...state, error: action.data }
    }
    case DELETE_SCENARIO_LOCATION_SUCCESS: {
      const items = state.items.filter((obj) => obj.id !== action.data)

      Logger.trace(LoggerTypes.REDUCER, '[REDUCER] scenarioLocations.DELETE_SCENARIO_LOCATION_SUCCESS()', {
        state,
        action,
        items
      })

      return {
        ...state,
        items
      }
    }

    // -- SEARCH SCENARIO
    case SEARCH_SCENARIO_LOCATIONS: {
      const txt = action.data || ''
      if (txt.length <= 1 && cacheItems === null && state.items) {
        cacheItems = [...state.items]
      }

      const escapeRegExp = (value) => value && value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')
      const searchRegex = new RegExp(escapeRegExp(txt), 'i')
      const searchItems = (cacheItems || []).filter((row) =>
        Object.keys(row).some((field) => searchRegex.test(((row && row[field]) || '').toString()))
      )
      return {
        ...state,
        items: searchItems
      }
    }

    default:
      return state
  }
}
